if (!customElements.get('bah-loop-video')) {
  customElements.define('bah-loop-video', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.video.loop = true;
      this.video.controls = false;
      this.video.playsInline = true;
      this.visible = false;
      this.sync = () => {
        if (!this.visible || document.hidden) { this.video.pause(); return; }
        if (!this.video.hasAttribute('src')) {
          const sources = [...this.video.querySelectorAll('source[data-src]')].sort((a,b) => Number(a.dataset.width) - Number(b.dataset.width));
          const target = Math.min(this.clientWidth * Math.min(window.devicePixelRatio || 1, 1.5), matchMedia('(max-width: 749px)').matches ? 720 : 1080);
          const chosen = sources.find(source => Number(source.dataset.width) >= target) || sources[sources.length - 1];
          if (!chosen) return;
          this.video.src = chosen.dataset.src;
          this.video.querySelectorAll('source').forEach(source => source.remove());
        }
        this.video.play().catch(() => {});
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
        this.sync();
      }, { threshold: [0, 0.1] });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.sync);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      document.removeEventListener('visibilitychange', this.sync);
      this.video?.pause();
    }
  });
}
